export default "__VITE_ASSET__BncvJ$pG__"